<template>
  <div
    class="sectionActionsContainer"
    @mouseover="isHovered = true"
    @mouseleave="isHovered = false"
  >
    <div
      v-if="
        showActions &&
        (isLocked ||
          commentsStore.enableComments ||
          isSynced ||
          (chatAIStore.chatAiIsEnable && chatAIStore.enabledChatAIOnSegment))
      "
      class="absolute right-[-17px] top-[-40px] z-[999] flex items-end px-4 pt-4 font-inter text-[9px] font-semibold text-white"
    >
      <div
        v-if="!isEditing"
        class="flex items-center overflow-hidden rounded-t-[3px]"
      >
        <a
          v-if="
            chatAIStore.chatAiIsEnable &&
            chatAIStore.enabledChatAIOnSegment &&
            !isEditing
          "
          v-tooltip.top="{ content: $t('editor.chat_ai_section') }"
          data-testid="chat-ai-structure"
          class="grid cursor-pointer items-center bg-structure-1 px-1 py-0.5 !text-white transition duration-300 hover:bg-structure-2"
          @click.stop="chatToSection"
        >
          <AIIconMono />
        </a>
        <a
          v-if="commentsStore.enableComments && !isEditing"
          v-tooltip.top="{ content: $t('editor.comment') }"
          data-testid="comment-structure"
          class="grid cursor-pointer items-center bg-structure-1 px-1 py-0.5 text-white transition duration-300 hover:bg-structure-2"
          @click.stop="commentSection"
        >
          <Comments />
        </a>
      </div>
      <div
        v-if="isSynced"
        class="ml-1 mt-[8px] flex items-center justify-center rounded-t-[3px] bg-structure-1 px-1 py-0.5 font-inter text-[9px] font-semibold leading-3 text-white"
      >
        <Rotate style="width: 10px; height: 12px" />
      </div>
      <div
        v-if="isLocked"
        class="mt-[8px] grid items-center justify-between rounded-t-[3px] bg-structure-1 px-1 py-0.5 leading-3"
      >
        <svg
          data-testid="section-lock-icon"
          style="width: 10px; height: 12px"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
            clip-rule="evenodd"
          ></path>
        </svg>
      </div>
    </div>
    <div
      v-if="showActions"
      class="absolute bottom-[-44px] right-[-17px] z-[999] box-border cursor-pointer px-4 pb-5 pt-[2px] text-sm leading-5"
    >
      <div
        v-if="!isEditing"
        class="flex items-center overflow-hidden rounded-b-[3px]"
      >
        <a
          v-if="isMovableForCurrentPermissions && isSynced"
          v-tooltip.top="{ content: $t('editor.edit') }"
          data-testid="edit-synced-structure"
          class="grid items-center bg-structure-1 px-1 py-0.5 !text-white transition duration-300 hover:bg-structure-2"
          @click.stop="$emit('edit-synced')"
        >
          <Pen />
        </a>
        <a
          v-if="isMovableForCurrentPermissions && isSynced"
          v-tooltip.top="{ content: $t('editor.unlink_synced') }"
          data-testid="unlink-synced-structure"
          class="grid items-center bg-structure-1 px-1 py-0.5 !text-white transition duration-300 hover:bg-structure-2"
          @click.stop="$emit('unlink-synced')"
        >
          <div class="grid h-[20px] w-[20px] items-center justify-center">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.13906 2.1958C2.87791 1.93473 2.45562 1.93473 2.19725 2.1958C1.93888 2.45687 1.9361 2.87901 2.19447 3.14008L16.8634 17.8042C17.1245 18.0653 17.5468 18.0653 17.8052 17.8042C18.0635 17.5431 18.0663 17.121 17.8052 16.8627L14.4158 13.4744C14.5325 13.38 14.6464 13.2772 14.7519 13.1717L16.7272 11.197C17.5412 10.3833 17.9997 9.2779 17.9997 8.12533C17.9997 5.72574 16.0549 3.77886 13.6518 3.77886C12.6155 3.77886 11.6209 4.14824 10.8375 4.81201C11.4014 5.09252 11.9126 5.46468 12.3516 5.90904C12.7433 5.67853 13.1906 5.55633 13.6518 5.55633C15.0714 5.55633 16.2216 6.70613 16.2216 8.12533C16.2216 8.80576 15.9521 9.45843 15.4687 9.94168L13.4934 11.9163C13.3851 12.0246 13.2684 12.1219 13.1434 12.208L11.8237 10.8887C12.2821 10.8637 12.6488 10.4888 12.6627 10.025C12.6627 9.98889 12.6627 9.95279 12.6627 9.91668C12.6627 7.51988 10.7208 5.5591 8.31485 5.5591C7.78143 5.5591 7.26191 5.65631 6.77295 5.84239L3.13906 2.1958ZM8.27595 7.33102C8.29262 7.33102 8.30651 7.33102 8.32318 7.33102C8.74269 7.33102 9.14275 7.43378 9.4928 7.6143C9.54281 7.64763 9.59282 7.67818 9.64561 7.7004C10.3902 8.1531 10.8902 8.97518 10.8902 9.91113C10.8902 9.92224 10.8902 9.93335 10.8902 9.94446L8.27595 7.33102ZM11.6181 14.4409L7.33414 10.1583C7.36748 12.5079 9.26777 14.4048 11.6153 14.4381L11.6181 14.4409ZM5.88114 8.70578L4.62262 7.44767L3.27242 8.79743C2.4584 9.61118 2 10.7165 2 11.8691C2 14.2687 3.94474 16.2156 6.34788 16.2156C7.38137 16.2156 8.37875 15.8462 9.1622 15.1824C8.59822 14.9019 8.08426 14.5298 7.6453 14.0854C7.25635 14.3131 6.80906 14.4353 6.34788 14.4353C4.92822 14.4353 3.77805 13.2855 3.77805 11.8663C3.77805 11.1859 4.04753 10.5332 4.53094 10.05L5.88114 8.70023V8.70578Z"
                fill="currentColor"
              />
            </svg>
          </div>
        </a>
        <a
          v-if="isMovableForCurrentPermissions"
          v-tooltip.top="{
            content: $t(duplicateAndCopyTooltip),
            html: true,
            placement: 'auto-start',
          }"
          data-testid="duplicate-structure"
          class="grid items-center bg-structure-1 px-1 py-0.5 !text-white transition duration-300 hover:bg-structure-2"
          @click.stop="copyOrDuplicate"
        >
          <Pipe v-if="copied" />
          <Copy v-else />
        </a>
        <a
          v-if="
            savedBlocksStore.syncedSectionsEnabled &&
            isMovableForCurrentPermissions &&
            !isSynced
          "
          v-tooltip.top="{ content: $t('editor.save_as_synced') }"
          data-testid="save-synced-section"
          class="grid items-center bg-structure-1 px-1 py-0.5 !text-white transition duration-300 hover:bg-structure-2"
          @click.stop="$emit('synced')"
        >
          <div class="grid h-[20px] w-[20px] items-center justify-center">
            <Rotate />
          </div>
        </a>
        <a
          v-if="
            savedBlocksStore.savedBlocks &&
            isMovableForCurrentPermissions &&
            !isSynced
          "
          v-tooltip.top="{ content: $t('editor.save_as_block') }"
          data-testid="save-structure"
          class="grid items-center bg-structure-1 px-1 py-0.5 !text-white transition duration-300 hover:bg-structure-2"
          @click.stop="$emit('save')"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.125 11.75L11.125 10.4648C11.125 9.23437 10.1133 8.25 8.88281 8.25C8.28125 8.25 7.95312 8.52344 7.78906 8.76953C7.65234 8.96094 7.46094 9.125 7.21484 9.125C6.94141 9.125 6.72266 8.90625 6.72266 8.63281L6.72266 8.55078C6.72266 8.49609 6.75 8.41406 6.77734 8.35937C6.99609 7.86719 8.11719 5.625 10.6875 5.625C12.8477 5.625 14.625 7.375 14.625 9.5625L14.625 11.75L16.293 11.75C16.8125 11.75 17.25 12.1602 17.25 12.6797C17.25 12.9258 17.1406 13.1445 17.0039 13.3086L13.5859 17.1094C13.3945 17.3008 13.1484 17.4375 12.875 17.4375C12.5742 17.4375 12.3281 17.3008 12.1367 17.1094L8.71875 13.3086C8.55469 13.1445 8.5 12.9258 8.5 12.707L8.5 12.625C8.5 12.1328 8.88281 11.75 9.375 11.75L11.125 11.75ZM14.625 4.3125C14.625 4.06641 14.4063 3.875 14.1875 3.875L5.4375 3.875C5.19141 3.875 5 4.06641 5 4.3125L5 13.0625C5 13.2812 5.19141 13.5 5.4375 13.5L6.75 13.5C7.21484 13.5 7.625 13.8828 7.625 14.375C7.625 14.8398 7.21484 15.25 6.75 15.25L5.4375 15.25C4.20703 15.25 3.25 14.2656 3.25 13.0625L3.25 4.3125C3.25 3.08203 4.20703 2.125 5.4375 2.125L14.1875 2.125C15.3906 2.125 16.375 3.08203 16.375 4.3125L16.375 5.625C16.375 6.08984 15.9648 6.5 15.5 6.5C15.0078 6.5 14.625 6.08984 14.625 5.625L14.625 4.3125Z"
              fill="currentColor"
            />
          </svg>
        </a>
        <a
          v-if="isMovableForCurrentPermissions"
          v-tooltip.top="{ content: $t('file_manager.delete') }"
          data-testid="delete-structure"
          class="grid items-center bg-structure-1 px-1 py-0.5 !text-white transition duration-300 hover:bg-destructive-2 hover:!text-white"
          @click.stop="$emit('remove')"
        >
          <Delete />
        </a>
      </div>
      <div
        v-if="isEditing"
        class="flex items-center overflow-hidden rounded-b-[3px]"
      >
        <span
          v-if="editedSyncedLang"
          v-tooltip.top="{
            content: $t('forms.synced_lang_badge_tooltip', {
              lang: editedSyncedLang,
            }),
          }"
          data-testid="synced-lang-badge"
          class="grid items-center bg-structure-1 px-1.5 py-0.5 text-[10px] font-bold uppercase !text-white"
        >
          {{ editedSyncedLang }}
        </span>
        <a
          v-tooltip.top="{ content: $t('editor.save') }"
          data-testid="save_edited_synced"
          class="grid items-center bg-structure-1 px-1 py-0.5 !text-white transition duration-300 hover:bg-structure-2"
          @click.stop="saveEditingRow"
        >
          <Check />
        </a>
        <a
          v-tooltip.top="{ content: $t('editor.cancel') }"
          data-testid="cancel-eddint-synced"
          class="grid items-center bg-structure-1 px-1 py-0.5 !text-white transition duration-300 hover:bg-structure-2"
          @click.stop="
            savedBlocksStore.editingRowUid = undefined;
            updateSyncedSections();
          "
        >
          <Close />
        </a>
      </div>
    </div>
    <SectionVariants :section-uid="sectionUid" />
    <addSection v-if="showActions" :show-paste="showPaste"></addSection>
    <arrowMovement
      v-if="showActions && isMovableForCurrentPermissions"
      :disable-down-movement="disableDownMovement"
      :disable-up-movement="disableUpMovement"
      :custom-left-pos="35"
      @doUpMovement="$emit('moveUpSection')"
      @doDownMovement="$emit('moveDownSection')"
    ></arrowMovement>
  </div>
</template>

<script lang="ts" setup>
  import addSection from "./addSection.vue";
  import arrowMovement from "./arrowMovement.vue";

  import {
    Copy,
    Comments,
    Delete,
    Rotate,
    Pen,
    Check,
    Close,
    Pipe,
    AIIconMono,
  } from "@topol/icons";

  import { useRolesStore } from "@/stores/roles";
  import { useMjmlStore } from "@/stores/mjmlStore";
  import { useSavedBlocksStore } from "@/stores/savedBlocksStore";
  import { useSyncedTranslationsStore } from "@/stores/syncedTranslationsStore";
  import { useCommentsStore } from "@/stores/commentsStore";
  import { useChatAI } from "@/stores/chatAIStore";
  import useSyncedSections from "@/composables/useBlocksFromAPI/useSyncedSections";

  import { useClipboard } from "@vueuse/core";
  import { ref, computed, defineAsyncComponent } from "vue";

  const { isSupported } = useClipboard();

  const SectionVariants = defineAsyncComponent(
    () => import("./sectionVariants.vue")
  );

  const props = defineProps([
    "disableUpMovement",
    "disableDownMovement",
    "isLocked",
    "sectionUid",
    "isSynced",
    "isEditing",
    "showPaste",
    "copied",
  ]);

  const emits = defineEmits([
    "moveUpSection",
    "moveDownSection",
    "save",
    "copy",
    "duplicate",
    "remove",
    "synced",
    "edit-synced",
    "unlink-synced",
  ]);

  const isHovered = ref(false);
  const rolesStore = useRolesStore();
  const mjmlStore = useMjmlStore();
  const savedBlocksStore = useSavedBlocksStore();
  const commentsStore = useCommentsStore();
  const chatAIStore = useChatAI();
  const syncedTranslationsStore = useSyncedTranslationsStore();
  const { saveEditingRow, updateSyncedSections } = useSyncedSections();

  const editedSyncedLang = computed(() => {
    if (mjmlStore.mjml.langs && mjmlStore.mjml.langs.length > 0) {
      return "";
    }
    const entry = syncedTranslationsStore.getSectionTranslation(
      props.sectionUid
    );
    if (!entry?.pickedLang) {
      return "";
    }
    if (Object.keys(entry.fullTranslation || {}).length <= 1) {
      return "";
    }
    return entry.pickedLang;
  });

  const showActions = computed(() => {
    return true;
  });

  const isMac = computed(() => {
    return navigator.platform.toUpperCase().indexOf("MAC") >= 0;
  });

  const duplicateAndCopyTooltip = computed(() => {
    if (!isSupported.value) {
      return "editor.duplicate";
    }

    if (isMac.value) {
      return "editor.duplicate_copy_mac";
    }

    return "editor.duplicate_copy";
  });

  const isMovableForCurrentPermissions = computed(() => {
    if (
      !props.isLocked ||
      (props.isLocked && rolesStore.permissions.canEditLockedSections)
    ) {
      return true;
    }

    return false;
  });

  function copyOrDuplicate(event: any) {
    if ((isMac.value && event.metaKey) || (!isMac.value && event.ctrlKey)) {
      if (isSupported.value) {
        emits("copy");
      }
    } else {
      emits("duplicate");
    }
  }

  function commentSection() {
    const sectionIndex = mjmlStore.getSectionIndexByUid(props.sectionUid);
    mjmlStore.selectSection({
      sectionIndex: sectionIndex,
    });
    commentsStore.openDetail = true;
    commentsStore.commentsOpen = true;
  }

  function chatToSection() {
    const sectionIndex = mjmlStore.getSectionIndexByUid(props.sectionUid);
    mjmlStore.selectSection({
      sectionIndex: sectionIndex,
    });
    chatAIStore.selectedUid = props.sectionUid;
    chatAIStore.isOpenedChat = true;
  }
</script>
